import documentReviewKPIReducer from "./documentReviewKPIReducer";
import applicationKPIReducer from "./applicationKPIReducer";
import inspectorKPIReducer from "./inspectorKPIReducer";

const kpiReducers = {
    documentReviewKPI: documentReviewKPIReducer,
    applicationKPI: applicationKPIReducer,
    inspectorKPI: inspectorKPIReducer,
}

export default kpiReducers;